import { Button, TextField, styled } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";

import ArrayField from "./arrayField";
import BooleanField from "./booleanField";
import CustomTextField from "./customTextField";
import Dropdown from "./dropdown";
import { CustomFieldsFormWrapper, CustomFieldsWrapper, FieldWrapper } from "./styles";


const StyledTextField = styled(TextField)`
  font-size: 14px;
  & .MuiOutlinedInput-input {
    font-size: 14px;
  }
`;

const FIELD_TYPES = {
  boolean: {
    initialValue: true,
    typeChecker: (value) => typeof value === "boolean",
    component: (props) => <BooleanField {...props} />,
  },
  string: {
    initialValue: "",
    typeChecker: (value) => typeof value === "string",
    component: (props) => <CustomTextField {...props} />,
  },
  array: {
    initialValue: [],
    typeChecker: (value) => Array.isArray(value),
    component: (props) => <ArrayField {...props} />,
  },
};

const mapFieldToComponent = (
  field,
  customFields,
  onChange,
  removeField
) => {
  for (const type in FIELD_TYPES) {
    if (!FIELD_TYPES[type].typeChecker(customFields[field])) {
      continue;
    }
    const props = {
      field,
      value: customFields[field],
      onChange,
    };
    return (
      <FieldWrapper key={field}>
        <span
          style={{
            marginRight: "1rem",
            verticalAlign: "middle",
            fontWeight: "bold",
            fontSize: "clamp(12px,0.5vw,18px)",
          }}
        >
          {field}:
        </span>
        {FIELD_TYPES[type].component(props)}
        <Button
          variant="contained"
          size="small"
          sx={{ textTransform: "none", mt: "1rem" }}
          onClick={() => removeField(field)}
        >
          Remove {field}
        </Button>
      </FieldWrapper>
    );
  }
  return null;
};

const CustomMetadata = ({ smartflowData, setSmartflowData }) => {
  const [fieldName, setFieldName] = useState("");
  const [fieldType, setFieldType] = useState("boolean");
  const customFields = { ...(smartflowData?.meta?.customFields ?? {}) };

  const addField = () => {
    if (fieldName.length < 3) {
      toast.warn("Field name should be more than 2 characters long");
      return;
    }
    if (customFields.hasOwnProperty(fieldName)) {
      toast.error(`${fieldName} already exists`);
      return;
    }
    setSmartflowData({
      ...smartflowData,
      meta: {
        ...smartflowData.meta,
        customFields: {
          ...customFields,
          [fieldName]: FIELD_TYPES[fieldType].initialValue,
        },
      },
    });
    setFieldName("");
  };

  const removeField = (field) => {
    if (!customFields.hasOwnProperty(field)) {
      toast.error(`${field} does not exist`);
      return;
    }
    const updatedFields = { ...customFields };
    delete updatedFields[field];
    setSmartflowData({
      ...smartflowData,
      meta: {
        ...smartflowData.meta,
        customFields: updatedFields,
      },
    });
  };

  const onChange = (field, value) => {
    setSmartflowData({
      ...smartflowData,
      meta: {
        ...smartflowData.meta,
        customFields: {
          ...customFields,
          [field]: value,
        },
      },
    });
  };

  const mapCallback = (field) =>
    mapFieldToComponent(field, customFields, onChange, removeField);

  return (
    <>
      <CustomFieldsWrapper>
        {Object.keys(customFields).map(mapCallback)}
      </CustomFieldsWrapper>
      <CustomFieldsFormWrapper>
        <StyledTextField
          type="text"
          disabled={false}
          id="custom-field-name"
          variant="outlined"
          value={fieldName}
          placeholder="Enter field name"
          onKeyDown={(event) => (event.key === "Enter" ? addField() : null)}
          onChange={(e) => setFieldName(e.target.value)}
          size="small"
        />
        <Dropdown type={fieldType} changeType={setFieldType} />
      </CustomFieldsFormWrapper>
      <div style={{display:'flex',justifyContent:'center',alignContent:'center'}}>
        <Button
        variant="contained"
        size="small"
        sx={{ textTransform: "none" }}
        onClick={addField}
        >
         Add custom field
      </Button>
      </div>
    </>
  );
};

export default CustomMetadata;
